<template>
  <div class="commonBg">
    <img src="../../../static/images/loading.gif" alt="" class="waitClass">
  </div>
</template>

<script>

export default {
  name: 'commonBg',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {}
}
</script>

<style lang="stylus" scoped>
.waitClass{
  width:.3rem
  height .3rem
  margin auto
}
.commonBg{
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0.8;
  margin: auto;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/commonBg.vue